export enum CountryEnum {
  'ALL' = '全部區域',
  'TW' = '台灣',
  'US' = '美國',
  'CA' = '加拿大',
}
